<template>
    <div >
        <el-dialog :visible.sync="visible" :before-close="close" :close-on-click-modal="false" width="500px">
            <div slot="title">
                <z-title title="修改密码"></z-title>
            </div>
            <el-form :model="data" :rules="rules" size="medium" ref="ruleForm" class="rulefrom" label-width="80px">
                <el-form-item label="原密码" prop="oldPassWord" label-width="120px">
                    <el-input maxlength="18" type="password" class="w-220" v-model="data.oldPassWord" placeholder="请输入原密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="passWord" label-width="120px">
                    <el-input maxlength="18" type="password" class="w-220" v-model="data.passWord" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="repeatpass" label-width="120px">
                    <el-input maxlength="18" type="password" class="w-220" v-model="data.repeatpass" placeholder="再次请输入新密码"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
                    <el-button @click="close">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>


    import ZTitle from "../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "setpassword",
        props:{
            visible: Boolean,
        },
        data(){
          return{
              data:{
                  oldPassWord:'',
                  passWord:'',
                  repeatpass:'',
              },
              rules:{
                  oldPassWord: [{required: true, message: '原密码不能为空', trigger: 'blur'}],
                  passWord: [{required: true, message: '新密码不能为空', trigger: 'blur'}],
                  repeatpass: [{required: true, message: '确认密码不能为空', trigger: 'blur'}]
              }
          }
        },
        methods:{
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.data.oldPassWord==this.data.passWord){
                            return this.$message.error('新密码与原密码不能相同');
                        }
                        if(this.data.repeatpass!=this.data.passWord)
                        {
                            return this.$message.error('新密码和确认密码不同');
                        }
                        var data=this.data;
                        this.$axios.post('/user/pcUpdatePassword', {
                            "id": this.$root.getStorage('info').userId,
                            "oldPassWord":data.oldPassWord,
                            "passWord":data.passWord
                        }).then(res => {
                            this.$message.success('账号密码修改成功');
                            this.close();
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })

                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            close() {
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped lang="scss">

</style>